var chunkToChildrenMap = {
	"199": [
		581
	],
	"616": [
		676
	],
	"642": [
		295
	],
	"744": [
		953,
		799
	],
	"754": [
		664,
		639
	],
	"917": [
		205
	],
	"984": [
		953
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));